module.exports = __webpack_public_path__ + "img/meetingclient10.ddd3e426.png";